@use 'styles/utils/variables' as *;

.input {
  border-radius: $radius-md;
}

.small {
  height: 2.4rem;
}

.middle {
  height: 3.2rem;
}

.large {
  height: 4rem;
}
